// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Dark Theme Colors */
  --bg-primary: #0a0e17;
  --bg-secondary: #111827;
  --bg-card: #1a2234;
  --bg-card-hover: #232f46;
  
  /* Text Colors */
  --text-primary: #f1f5f9;
  --text-secondary: #94a3b8;
  --text-muted: #64748b;
  
  /* Accent Colors */
  --accent-blue: #3b82f6;
  --accent-cyan: #06b6d4;
  --accent-green: #10b981;
  --accent-yellow: #f59e0b;
  --accent-orange: #f97316;
  --accent-red: #ef4444;
  --accent-purple: #8b5cf6;
  
  /* Alert Colors */
  --alert-extreme: #dc2626;
  --alert-severe: #f97316;
  --alert-moderate: #f59e0b;
  --alert-minor: #3b82f6;
  
  /* Border & Shadow */
  --border-color: #2d3748;
  --shadow-lg: 0 10px 40px rgba(0, 0, 0, 0.4);
  
  /* Spacing */
  --spacing-xs: 4px;
  --spacing-sm: 8px;
  --spacing-md: 16px;
  --spacing-lg: 24px;
  --spacing-xl: 32px;
  
  /* Border Radius */
  --radius-sm: 6px;
  --radius-md: 10px;
  --radius-lg: 16px;
  
  /* Transitions */
  --transition-fast: 150ms ease;
  --transition-normal: 300ms ease;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  line-height: 1.5;
  overflow-x: hidden;
}

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: var(--bg-secondary);
}

::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--text-muted);
}

/* Icon styles */
.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.icon svg {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;;EAExB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;EACrB,wBAAwB;;EAExB,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;;EAEtB,oBAAoB;EACpB,uBAAuB;EACvB,2CAA2C;;EAE3C,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;;EAEjB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uFAAuF;EACvF,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[":root {\n  /* Dark Theme Colors */\n  --bg-primary: #0a0e17;\n  --bg-secondary: #111827;\n  --bg-card: #1a2234;\n  --bg-card-hover: #232f46;\n  \n  /* Text Colors */\n  --text-primary: #f1f5f9;\n  --text-secondary: #94a3b8;\n  --text-muted: #64748b;\n  \n  /* Accent Colors */\n  --accent-blue: #3b82f6;\n  --accent-cyan: #06b6d4;\n  --accent-green: #10b981;\n  --accent-yellow: #f59e0b;\n  --accent-orange: #f97316;\n  --accent-red: #ef4444;\n  --accent-purple: #8b5cf6;\n  \n  /* Alert Colors */\n  --alert-extreme: #dc2626;\n  --alert-severe: #f97316;\n  --alert-moderate: #f59e0b;\n  --alert-minor: #3b82f6;\n  \n  /* Border & Shadow */\n  --border-color: #2d3748;\n  --shadow-lg: 0 10px 40px rgba(0, 0, 0, 0.4);\n  \n  /* Spacing */\n  --spacing-xs: 4px;\n  --spacing-sm: 8px;\n  --spacing-md: 16px;\n  --spacing-lg: 24px;\n  --spacing-xl: 32px;\n  \n  /* Border Radius */\n  --radius-sm: 6px;\n  --radius-md: 10px;\n  --radius-lg: 16px;\n  \n  /* Transitions */\n  --transition-fast: 150ms ease;\n  --transition-normal: 300ms ease;\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  line-height: 1.5;\n  overflow-x: hidden;\n}\n\n/* Scrollbar Styling */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--bg-secondary);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--border-color);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--text-muted);\n}\n\n/* Icon styles */\n.icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.icon svg {\n  width: 100%;\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
